class DeletePicklist {
    constructor(Alert, $http, $state, $stateParams, SweetAlert, $translate) {

        this.key = 'archive-picklist';
        this.title = 'Archive';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.order = 15;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
        this.translate = $translate;
    }

    action({},store) {
        // @todo new alert - check when displaying archived picklist is fixed, right now you can't get to this screen
        const translatedValue = (path, params) => {
            return this.translate.instant(`picklists.workflows.ask-to-delete-picklist.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {picklist_name: store.state.vm.picklist.name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            },
        ).then(() => {
            return this.api.delete(`picklists/${ store.state.vm.picklist.id }`, {data: {force: true}})
                .then(() => {
                    this.alert.success('Success', 'Picklist has been deleted');
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.picklists')
    .factory('deletePicklist', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        'SweetAlert',
        (Alert, $http, $state, $stateParams, SweetAlert, $translate) => new DeletePicklist(Alert, $http, $state, $stateParams, SweetAlert, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/picklists/workflows/general/delete-picklist.js